import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

const INITIAL_SUBMIT_BODY = {
  name: '',
  queue_path: '',
  scheduled_start_datetime: '',
  scheduled_start_timezone: '',
  parameters: [],
  note: '',
  schedule: {},
  hold_on_submit: false,
};

// Submit a node definition
// export const submitNode = createAsyncThunk(
//     'nodeSubmit/submitNode',
//     async (submitBody: typeof INITIAL_SUBMIT_BODY) => {
//         const response = await api.post('/node_definitions_schedule', submitBody);
//         return response.data;
//     }
// );
export const submitNode = createAsyncThunk(
  'nodeSubmit/submitNode',
  async ({ zone_name, name, data }: { zone_name?: string; name: string; data: typeof INITIAL_SUBMIT_BODY }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/node_schedule/${zone_name}/${name}`, data);
      return response.data;
    } catch (err: any) {
      if (err.response?.data?.error) {
        return rejectWithValue(err.response.data);
      }
      // Fallback for network errors or unknown issues
      return rejectWithValue({ error: err.message || 'Unknown error' });
    }
  }
);

interface NodeSubmitState {
  status: string | null;
  error: string | null;
  rootNodeInstanceId: number | null;
}

const initialState: NodeSubmitState = {
  status: null,
  error: null,
  rootNodeInstanceId: null,
};

const nodeSubmitSlice = createSlice({
  name: 'nodeSubmit',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitNode.pending, (state) => {
        state.status = 'loading';
        state.error = null;
        state.rootNodeInstanceId = null;
      })
      .addCase(submitNode.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.rootNodeInstanceId = action.payload.node_instance.node_instance_id;
      })
      .addCase(submitNode.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'An error occurred';
      });
  },
});

export default nodeSubmitSlice.reducer;
